var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { CommonConstant } from '../../../app.constants';
import { UserProfile } from '../../../../models/user';
import { UserService } from '../../../services/user.service';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { TranslateService } from '@ngx-translate/core';
import { WebUtils } from '../../../utils/web.utils';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '../../../services/modal/modal.service';
var SignUpFormComponent = /** @class */ (function () {
    function SignUpFormComponent(formBuilder, userService, modalService, translate, activatedRoute, placeholderService) {
        this.formBuilder = formBuilder;
        this.userService = userService;
        this.modalService = modalService;
        this.translate = translate;
        this.activatedRoute = activatedRoute;
        this.placeholderService = placeholderService;
        this.signUpSuccessCallback = new EventEmitter();
        this.passwordControl = new FormControl(undefined, {
            validators: this.validatePassword.bind(this),
            updateOn: 'blur'
        });
        this.confirmPasswordControl = new FormControl(undefined, {
            validators: this.validatePassword.bind(this),
            updateOn: 'blur'
        });
    }
    SignUpFormComponent.prototype.validatePassword = function () {
        if (!this.newUser) {
            return null;
        }
        var password = this.newUser.controls.password.value;
        var confirmPassword = this.newUser.controls.confirmPassword.value;
        if (!confirmPassword && !password) {
            return null;
        }
        if (confirmPassword !== password) {
            return {
                doesMatchPassword: false
            };
        }
        return null;
    };
    SignUpFormComponent.prototype.validateEmail = function (emailFormControl) {
        if (!emailFormControl) {
            return null;
        }
        if (!WebUtils.validateEmail(emailFormControl.value)) {
            return {
                invalidEmail: true
            };
        }
        return null;
    };
    SignUpFormComponent.prototype.onUpdateTermAndServiceAgreement = function () {
        this._errorMessage = undefined;
    };
    SignUpFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.newUser = this.formBuilder.group({
            fullName: [null, Validators.required],
            email: [null, [Validators.required, this.validateEmail.bind(this)]],
            password: this.passwordControl,
            confirmPassword: this.confirmPasswordControl,
            acceptTermService: [null]
        });
        this.confirmPasswordControl.valueChanges.subscribe(function (evt) {
            if (evt) {
                _this.passwordControl.updateValueAndValidity();
            }
        });
        this.activatedRoute.params.subscribe(function (res) {
            if (res.hashKey) {
                _this.hashKey = res.hashKey;
                _this.placeholderService.show(CommonConstant.LOGIN_PLACEHOLDER);
                _this.userService.precheckHashLink(res.hashKey).subscribe(function (user) {
                    _this.invitedCompany = user;
                    _this.newUser.patchValue({ email: user.email });
                    _this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
                }, function (err) {
                    _this._errorMessage = err.error.message;
                    _this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
                });
            }
        });
        if (this.activatedRoute.snapshot.queryParamMap.has('plan_id')) {
            this.planId = this.activatedRoute.snapshot.queryParamMap.get('plan_id');
        }
    };
    SignUpFormComponent.prototype.onSubmit = function (_a) {
        var _this = this;
        var value = _a.value, valid = _a.valid;
        var isAcceptTermService = value.acceptTermService;
        if (!isAcceptTermService) {
            this._errorMessage = this.translate.instant('register.error_term_service_missing');
            return;
        }
        if (valid && isAcceptTermService) {
            this.placeholderService.show(CommonConstant.LOGIN_PLACEHOLDER);
            if (this.invitedCompany) {
                var data = new UserProfile();
                data.fullName = value.fullName;
                data.email = value.email;
                data.password = value.password;
                data.confirmPassword = value.confirmPassword;
                data.country = CommonConstant.INTERNATIONAL_ID;
                this.userService.acceptionInvitation(this.hashKey, data, this.companyName).subscribe(function (res) {
                    _this.onSuccess(value, res);
                });
            }
            else {
                if (this.planId) {
                    value.plan_id = this.planId;
                }
                this.userService.signUp(value).subscribe(function (res) {
                    _this.onSuccess(value, res);
                }, function (err) {
                    _this.onError(_this.buildErrorMessage(err));
                });
            }
        }
        else {
            this.onError(this.translate.instant('register.error_term_service_missing'));
        }
        return false;
    };
    SignUpFormComponent.prototype.buildErrorMessage = function (err) {
        var errorMsg;
        if (err && err.error && err.error.message === 'invalid_email') {
            errorMsg = this.translate.instant('register.error_email_invalid');
        }
        else if (err && err.error && err.error.data === 'user_invalid') {
            errorMsg = this.translate.instant('register.error_email_used');
        }
        else if (err && err.error && err.error.data === 'user_invalid') {
            errorMsg = this.translate.instant('register.invalid_plan');
        }
        else {
            errorMsg = this.translate.instant('register.unexpected_error');
        }
        return errorMsg;
    };
    SignUpFormComponent.prototype.onSuccess = function (user, res) {
        this.signUpSuccessCallback.emit({
            invited: this.invitedCompany !== undefined,
            userData: __assign({ email: user.email }, res)
        });
    };
    SignUpFormComponent.prototype.onError = function (errorMsg) {
        this._errorMessage = errorMsg;
        this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
    };
    Object.defineProperty(SignUpFormComponent.prototype, "errorMessage", {
        get: function () {
            var _this = this;
            if (this._errorMessage && this._errorMessage !== '') {
                return this._errorMessage;
            }
            if (!this.newUser || !this.newUser.controls) {
                return null;
            }
            if (this.newUser.controls.email && this.newUser.controls.email.touched
                && this.newUser.controls.email.errors
                && this.newUser.controls.email.errors.invalidEmail === true) {
                return this.translate.instant('register.invalid_email_message');
            }
            if (this.newUser.controls.password
                && this.newUser.controls.password.touched
                && this.newUser.controls.password.errors
                && this.newUser.controls.password.errors.doesMatchPassword === false) {
                return this.translate.instant('register.error_password_not_match');
            }
            var hasErrors = false;
            Object.keys(this.newUser.controls).forEach(function (k) {
                if (_this.newUser.controls[k].touched && _this.newUser.controls[k].errors) {
                    hasErrors = true;
                }
            });
            if (hasErrors) {
                return this.translate.instant('register.error_missing_required');
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpFormComponent.prototype, "companyName", {
        get: function () {
            return this.invitedCompany ? this.invitedCompany.tempCompanyName : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpFormComponent.prototype, "accountId", {
        get: function () {
            return this.invitedCompany ? this.invitedCompany.id : '';
        },
        enumerable: true,
        configurable: true
    });
    SignUpFormComponent.prototype.openSupport = function () {
        if (typeof window.Intercom === 'function') {
            window.Intercom('showMessages');
        }
    };
    return SignUpFormComponent;
}());
export { SignUpFormComponent };



// WEBPACK FOOTER //
// ./src/app/auth/sign-up/sign-up-form/sign-up-form.component.ts.pre-build-optimizer.js